import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=52d68495"
var script = {}
import style0 from "./PostView.vue?vue&type=style&index=0&id=52d68495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconsTag: require('/home/node/app/components/ui/icons/tag.vue').default,ControllerPost: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerPost.js').default})
